<template>
  <div class="customer-account-query">
    <div class="page-header">
      <h2>顾客账号查询</h2>
      <p>只读查看顾客微信授权账号、手机号和服务号关注状态</p>
    </div>

    <div class="page-content">
      <div class="search-section">
        <div class="search-box">
          <select v-model="searchStoreId" class="store-select" @change="handleSearch">
            <option value="">全部门店</option>
            <option v-for="store in storeList" :key="store.id" :value="store.id">{{ store.storeName }}</option>
          </select>
          <input v-model="searchKeyword" class="search-input" placeholder="搜索昵称/手机号/openid" @keyup.enter="handleSearch" />
          <button class="search-btn" @click="handleSearch">搜索</button>
          <button class="reset-btn" @click="handleReset">重置</button>
        </div>
      </div>

      <div class="notice-card">
        顾客账号只能通过小程序微信授权建档，这里不提供手动新增或改手机号入口。
      </div>

      <div class="table-section">
        <div class="table-header">
          <h3>顾客账号列表</h3>
        </div>
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>头像</th>
                <th>微信昵称</th>
                <th>手机号</th>
                <th>所属门店</th>
                <th>小程序 OpenID</th>
                <th>UnionID</th>
                <th>服务号</th>
                <th>最近登录</th>
                <th>建档时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" class="empty-cell">加载中...</td>
              </tr>
              <tr v-else-if="customerList.length === 0">
                <td colspan="9" class="empty-cell">暂无顾客账号</td>
              </tr>
              <tr v-else v-for="customer in customerList" :key="customer.id">
                <td>
                  <img v-if="customer.avatarUrl" :src="customer.avatarUrl" class="avatar" />
                  <span v-else class="avatar-placeholder">-</span>
                </td>
                <td>{{ customer.nickname || customer.realName || customer.username || '-' }}</td>
                <td>{{ customer.phone || '-' }}</td>
                <td>{{ getStoreName(customer.storeId) }}</td>
                <td class="mono-cell">{{ customer.openid || customer.mpOpenid || '-' }}</td>
                <td class="mono-cell">{{ customer.unionid || customer.mpUnionid || '-' }}</td>
                <td>
                  <span :class="['status-badge', isSubscribed(customer) ? 'active' : 'inactive']">
                    {{ isSubscribed(customer) ? '已关注' : '未关注' }}
                  </span>
                </td>
                <td>{{ formatDate(customer.lastLoginTime || customer.lastLoginAt) }}</td>
                <td>{{ formatDate(customer.createdTime || customer.createTime) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'CustomerAccountQuery',
  data() {
    return {
      customerList: [],
      storeList: [],
      searchStoreId: '',
      searchKeyword: '',
      loading: false
    }
  },
  mounted() {
    this.loadStoreList()
    this.loadCustomerList()
  },
  methods: {
    async loadStoreList() {
      const response = await request.get('/api/stores/getStores', { params: { page: 0, size: 1000 } })
      if (response.data.success && response.data.code === 200) {
        this.storeList = response.data.data.content || []
      }
    },
    async loadCustomerList() {
      this.loading = true
      try {
        const response = await request.get('/api/users/getUsers', {
          params: {
            page: 0,
            size: 5000,
            role: 'CUSTOMER',
            storeId: this.searchStoreId || undefined,
            keyword: this.searchKeyword || undefined
          }
        })
        if (response.data.success && response.data.code === 200) {
          this.customerList = response.data.data.content || []
        }
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.loadCustomerList()
    },
    handleReset() {
      this.searchStoreId = ''
      this.searchKeyword = ''
      this.loadCustomerList()
    },
    getStoreName(storeId) {
      const store = this.storeList.find(item => String(item.id) === String(storeId))
      return store ? store.storeName : '-'
    },
    isSubscribed(customer) {
      return customer.subscribeStatus === true || customer.subscribeStatus === 1 || customer.subscribeStatus === '1'
    },
    formatDate(value) {
      if (!value) return '-'
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.page-header { margin-bottom: 24px; }
.page-header h2 { margin: 0 0 8px; color: #333; }
.page-header p { margin: 0; color: #666; }
.page-content, .table-section { background: #fff; border-radius: 8px; padding: 20px; }
.search-section { margin-bottom: 16px; }
.search-box { display: flex; flex-wrap: wrap; gap: 12px; }
.search-input, .store-select { height: 36px; padding: 0 12px; border: 1px solid #d9d9d9; border-radius: 6px; }
.search-input { width: 260px; }
button { border: none; border-radius: 6px; padding: 8px 16px; cursor: pointer; }
.search-btn { background: #1890ff; color: #fff; }
.reset-btn { background: #f5f5f5; color: #333; }
.notice-card { padding: 12px 16px; margin-bottom: 20px; border: 1px solid #91d5ff; background: #e6f7ff; border-radius: 6px; color: #0958d9; }
.table-container { overflow-x: auto; }
.data-table { width: 100%; min-width: 1100px; border-collapse: collapse; }
.data-table th, .data-table td { padding: 12px; border-bottom: 1px solid #f0f0f0; text-align: left; }
.empty-cell { text-align: center; color: #999; padding: 40px; }
.avatar { width: 36px; height: 36px; border-radius: 50%; object-fit: cover; }
.avatar-placeholder { display: inline-flex; width: 36px; height: 36px; align-items: center; justify-content: center; background: #f5f5f5; border-radius: 50%; color: #999; }
.mono-cell { max-width: 180px; font-family: Consolas, monospace; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.status-badge { padding: 4px 8px; border-radius: 4px; font-size: 12px; }
.status-badge.active { background: #f6ffed; color: #52c41a; }
.status-badge.inactive { background: #fff7e6; color: #fa8c16; }
</style>
